import { Injectable } from '@angular/core';
import { Message, MessageService } from 'primeng';

const successLifeInMilliseconds = 1500;

@Injectable({
  providedIn: 'root',
})
export class ToastNotificationService {
  constructor(private messageService: MessageService) {}

  public success(message: string, lifetime: number = undefined): void {
    this.createMessageToast(message, 'success', lifetime);
  }

  public error(message: string, lifetime: number = undefined): void {
    this.createMessageToast(message, 'error', lifetime);
  }

  private createMessageToast(detail: string, severity: 'success' | 'error', lifetime: number = undefined): void {
    const responseMessage: Message = {
      severity,
      detail: detail,
      life: lifetime ?? successLifeInMilliseconds,
      key: 'app-notifier',
      data: {
        msgType: 'locale',
      },
    };

    if (this.messageService) {
      this.messageService.clear('app-notifier');
      this.messageService.add(responseMessage);
    }
  }
}
